import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  incidentId: string;
};

const newIncidentId = (): string => Date.now().toString(36);

class BillingErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
    incidentId: newIncidentId()
  };

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  componentDidCatch(): void {
    // Intentionally no side effects: UI already tracks errors in checkout flow.
  }

  render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <section className="section store-billing-shell">
        <div className="section-header">
          <h2>Plan & Billings</h2>
          <p>We couldn&apos;t load your billing information. Please refresh or contact support if the problem persists.</p>
        </div>
        <div className="card">
          <div className="billing-muted">Incident ID: <strong className="billing-tabular">{this.state.incidentId}</strong></div>
          <div className="inline-actions">
            <button type="button" className="btn primary" onClick={() => window.location.reload()}>Refresh</button>
            <button
              type="button"
              className="btn ghost"
              onClick={() => navigator.clipboard?.writeText(this.state.incidentId)}
            >
              Copy ID
            </button>
          </div>
          <div className="billing-muted">
            Need help? <a href="/support">Contact support</a>
          </div>
        </div>
      </section>
    );
  }
}

export default BillingErrorBoundary;

